var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerousRoadWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0856 3.12983C12.6057 2.29006 11.3948 2.29006 10.915 3.12983L3.66876 15.8109C3.19258 16.6442 3.79429 17.6811 4.75406 17.6811L19.2466 17.6811C20.2064 17.6811 20.8081 16.6443 20.332 15.811L13.0856 3.12983ZM9.61261 2.38563C10.6683 0.538133 13.3322 0.538117 14.388 2.38562L21.6343 15.0668C22.6819 16.9001 21.3581 19.1811 19.2466 19.1811L4.75405 19.1811C2.64256 19.1811 1.3188 16.9 2.36639 15.0667L9.61261 2.38563ZM11.6966 6.49236C12.1108 6.49236 12.4466 6.82815 12.4466 7.24236V11.9946C12.4466 12.4088 12.1108 12.7446 11.6966 12.7446C11.2824 12.7446 10.9466 12.4088 10.9466 11.9946V7.24236C10.9466 6.82815 11.2824 6.49236 11.6966 6.49236ZM11.9887 15.871C12.5642 15.871 13.0307 15.4044 13.0307 14.8289C13.0307 14.2534 12.5642 13.7869 11.9887 13.7869C11.4132 13.7869 10.9466 14.2534 10.9466 14.8289C10.9466 15.4044 11.4132 15.871 11.9887 15.871Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerousRoadWhite);
export default __webpack_public_path__ + "static/media/dangerous-road-white.bd385f66832b60c02720cdd827e168cf.svg";
export { ForwardRef as ReactComponent };